import styles from "./ChapterCardSkeleton.module.scss";

const ChapterCardSkeleton = () => (
  <div className={styles.card} aria-hidden="true">
    <div className={styles.banner}>
      <div className={styles.pinPlaceholder} />
      <div className={styles.titlePlaceholder} />
    </div>

    <div className={styles.body}>
      <div className={styles.statsRow}>
        <div className={styles.stat}>
          <div className={styles.statValuePlaceholder} />
          <div className={styles.statLabelPlaceholder} />
        </div>
        <div className={styles.stat}>
          <div className={styles.statValuePlaceholder} />
          <div className={styles.statLabelPlaceholder} />
        </div>
        <div className={styles.stat}>
          <div className={styles.statValuePlaceholder} />
          <div className={styles.statLabelPlaceholder} />
        </div>
      </div>

      <div className={styles.footer}>
        <div className={styles.leadBlock}>
          <div className={styles.leadLabelPlaceholder} />
          <div className={styles.leadNamePlaceholder} />
        </div>
        <div className={styles.managePlaceholder} />
      </div>
    </div>
  </div>
);

export default ChapterCardSkeleton;
